//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FollowRules',
  props: {
    formData: {
      default: function _default() {},
      type: Object
    }
  },
  data: function data() {
    return {
      grid1: {
        xl: 2,
        lg: 4,
        md: 2,
        sm: 24,
        xs: 24
      },
      grid2: {
        xl: 20,
        lg: 18,
        md: 20,
        sm: 24,
        xs: 24
      },
      rules: {
        follow_up_unsettled: [{
          required: true,
          message: '请输入客户跟进提醒周期'
        }],
        follow_up_traded: [{
          required: true,
          message: '请输入客户跟进提醒周期'
        }]
      }
    };
  },
  watch: {
    'formData.follow_up_unsettled': function formDataFollow_up_unsettled(newValue, oldValue) {
      if (newValue === '') {
        return;
      }
      var numericValue = parseInt(newValue, 10);
      if (isNaN(numericValue)) {
        this.formData.follow_up_unsettled = oldValue || '';
      } else {
        this.formData.follow_up_unsettled = Math.abs(numericValue).toString();
      }
    },
    'formData.follow_up_traded': function formDataFollow_up_traded(newValue, oldValue) {
      if (newValue === '') {
        return;
      }
      var numericValue = parseInt(newValue, 10);
      if (isNaN(numericValue)) {
        this.formData.follow_up_traded = oldValue || '';
      } else {
        this.formData.follow_up_traded = Math.abs(numericValue).toString();
      }
    }
  },
  methods: {
    handleCheckChange: function handleCheckChange(value) {
      this.formData.follow_up_status = value;
    },
    sendFollowData: function sendFollowData() {
      var data = this.formData;
      this.$emit('followData', data);
    },
    saveEvt: function saveEvt() {
      this.$emit('saveEvt');
    },
    getVal: function getVal(type) {
      return typeof this.formData.follow_up_status != 'undefined' && this.formData.follow_up_status.includes(type.toString());
    }
  }
};